export const MARKET_EXECUTIVE_COMMISSION_COMPANY_REQUEST = "MARKET_EXECUTIVE_COMMISSION_COMPANY_REQUEST";
export const MARKET_EXECUTIVE_COMMISSION_COMPANY_SUCCESS = "MARKET_EXECUTIVE_COMMISSION_COMPANY_SUCCESS";
export const MARKET_EXECUTIVE_COMMISSION_COMPANY_FAILED = "MARKET_EXECUTIVE_COMMISSION_COMPANY_FAILED";